import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import config from '../../../config/config';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2'; // Import SweetAlert2
import Dropzone from 'react-dropzone';
function AddUpdateBanner(props) {
    const rawParams = useParams();
    const id = rawParams.id ?? '0'; // or Number(rawParams.id ?? 0);
    const navigate = useNavigate();
    const [fileNames, setFileNames] = useState([]);
    const [formData, setFormData] = useState({
        page: '',
        title: '',
        description: '',
        image: [],
    });
    const [errors, setErrors] = useState({});
    useEffect(() => {

        if (id !== 0) {
            config.getBannerById({ id }).then((response) => {
                const res = response.data;


                // Update form data
                setFormData({
               
                    title: res.title || '',
                    page: res.page || '',
                    description: res.description || '',
           
                    image: res.image ? res.image.split(',') : [],
                });
                setFileNames(res.image ? res.image.split(',') : []);
            }).catch((error) => {
                console.error('Error fetching user:', error);
            });
        }
    }, []);
    ;


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.page.trim()) newErrors.page = 'Page is required';
        if (!formData.title.trim()) newErrors.title = 'Title is required';
        if (!formData.description.trim()) newErrors.description = 'Description is required';
        if (!formData.image) newErrors.image = 'Image is required';
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            Swal.fire('Validation Error', 'Please correct the highlighted fields.', 'warning');
        } else {
            setErrors({});
            try {
                let response;
                if (id !== '0') {
                    const payload = { ...formData, id };
                    response = await config.createBanner(payload); // Update user
                    Swal.fire({ text: response.data.message || 'User updated successfully!', icon: response.data.icon }).then((result) => {
                        if (result.isConfirmed) {
                            navigate(-1);
                        }
                    });
                } else {
                    response = await config.createBanner(formData); // Add new user
                    Swal.fire({ text: response.data.message || 'User added successfully!', icon: response.data.icon }).then((result) => {
                        if (result.isConfirmed) {
                            navigate(-1);
                        }
                    });

                    setFormData({
                        page: '',
                        title: '',
                        description: '',
                    });
               
                }



            } catch (error) {
                console.error('Submission Error:', error);

                let errorMsg = 'Something went wrong. Please try again later.';
                if (error.response?.data?.errors) {
                    const firstError = Object.values(error.response.data.errors)[0];
                    errorMsg = Array.isArray(firstError) ? firstError[0] : firstError;
                } else if (error.response?.data?.message) {
                    errorMsg = error.response.data.message;
                }

                // Swal.fire('Error', errorMsg, 'error');
                Swal.fire({ text: errorMsg, icon: 'error' }).then((result) => {
                    if (result.isConfirmed) {
                        navigate(-1);
                    }
                });
            }
        }
    };

    const handleFileUpload = async (acceptedFiles) => {
        if (!acceptedFiles.length) return;

        // Only take the first image (ignore multiple selections)
        const file = acceptedFiles[0];
        const formData = new FormData();
        formData.append('file', file);

        try {
            const res = await config.bannerImageUpload(formData);

            // Save only one filename
            const uploadedFile = res.data.filename;

            setFileNames([uploadedFile]); // only one image
            setFormData((prev) => ({
                ...prev,
                image: uploadedFile, // store as string (not array)
            }));
        } catch (error) {
            console.error('Upload error:', error);
            Swal.fire('Error', 'Failed to upload file.', 'error');
        }
    };




    return (
        <div className='page-inner'>
            <div className="page-header">
                <h3 className="fw-bold mb-3">Add Banner</h3>
                <ul className="breadcrumbs mb-3">
                    <li className="nav-home">
                        <a href="#"><i className="fas fa-image"></i></a>
                    </li>
                    <li className="separator"><i className="fa-solid fa-greater-than"></i></li>
                    <li className="nav-item"><a href="#">Banner List</a></li>
                    <li className="separator"><i className="fa-solid fa-greater-than"></i></li>
                    <li className="nav-item"><a href="#">Add Baneer</a></li>
                </ul>
            </div>

            <div className='row'>
                <div className='col-md-12'>
                    <div className='card'>
                        <div className='card-header'>
                            <div className='card-title'>Banner Details</div>
                        </div>
                        <div className='card-body'>
                            <Form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-xl-4 mb-3">
                                        <Form.Group controlId="page">
                                            <Form.Label>Page</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="page"
                                                value={formData.page}
                                                onChange={handleChange}
                                                isInvalid={!!errors.page}
                                                placeholder="Enter Page"
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="col-xl-4 mb-3">
                                        <Form.Group controlId="title">
                                            <Form.Label>Title</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="title"
                                                value={formData.title}
                                                onChange={handleChange}
                                                isInvalid={!!errors.title}
                                                placeholder="Enter Title"
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>


                                </div>


                                <div className="row">
                                    <div className="col-xl-6 mb-3">
                                        <Form.Group controlId="description">
                                            <Form.Label>Description</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={2}
                                                name="description"
                                                value={formData.description}
                                                onChange={handleChange}
                                                isInvalid={!!errors.description}
                                                placeholder="Enter Description"
                                            />
                                            <Form.Control.Feedback type="invalid">{errors.address}</Form.Control.Feedback>
                                        </Form.Group>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-xl-6 mb-3">
                                        <Form.Group>
                                            <Form.Label>Upload File</Form.Label>
                                            <Dropzone onDrop={handleFileUpload}>
                                                {/* <Dropzone onDrop={handleFileUpload} multiple> */}
                                                {({ getRootProps, getInputProps }) => (
                                                    <div {...getRootProps()} className="dropzone border p-3 rounded text-center" style={{ cursor: 'pointer' }}>
                                                        <input {...getInputProps()} />
                                                        <p>Drag & drop files here, or click to select</p>

                                                        <div className="d-flex flex-wrap justify-content-start mt-2 gap-2">
                                                            {fileNames.map((file, idx) => (
                                                                <div key={idx} className="position-relative">
                                                                    <img
                                                                        src={`${config.BASE_URL}/uploads/banners/${file}`}
                                                                        alt={`preview-${idx}`}
                                                                        style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '4px' }}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </Dropzone>


                                            {errors.image && (
                                                <div className="text-danger mt-1">{errors.image}</div>
                                            )}

                                        </Form.Group>
                                    </div>
                                </div>
                                <div className="card-action d-flex gap-2">
                                    <button type="submit" className="btn btn-success">Submit</button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => navigate(-1)}
                                    >
                                        Back
                                    </button>

                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddUpdateBanner;
